import React, { FC } from 'react'

import styles from './AssetPreviewModalHeader.module.scss'

import DownloadIcon from '~icons/download.svg'
import Box from '~lib/ui-kit/Box'
import Space from '~lib/ui-kit/Space'
import Text from '~lib/ui-kit/Text'

interface AssetPreviewModalHeaderProps {
  name: string
  onDownload: VoidFunction
}

const AssetPreviewModalHeader: FC<React.PropsWithChildren<AssetPreviewModalHeaderProps>> = ({ name, onDownload }) => {
  return (
    <Box className={styles.root}>
      <Space className="px-2 py-1-5" justify="space-between">
        <Text>{name}</Text>
        <button type="button" onClick={onDownload}>
          <DownloadIcon />
        </button>
      </Space>
    </Box>
  )
}

export default AssetPreviewModalHeader
